import axios from "axios";


const FORGOTPASS_IS_LOADING = "FORGOTPASS_IS_LOADING";
const FORGOTPASS_SUBMIT = "FORGOTPASS_SUBMIT";

export const actionCreators = {
    forgotPassword: state => async (dispatch, getState) => {
        if (getState().forgotPassword.isLoading) {
            return;
        }
        try {
            dispatch({ type: FORGOTPASS_IS_LOADING, isLoading: true});
            const url = `api/account/forgot-password`;
            const response = await axios.post(url, state);
            //let Message = response.data;
            dispatch({ type: FORGOTPASS_SUBMIT, Message: response.data});
            dispatch({ type: FORGOTPASS_IS_LOADING, isLoading: false});
        }
        catch (e) {
            dispatch({ type: FORGOTPASS_IS_LOADING, isLoading: false});
            throw e;
        }
    }
};

const initialState = {
    Email: {},
    isLoading: false,
    EmailSent: false,
    Message: null
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case FORGOTPASS_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case FORGOTPASS_SUBMIT:
            return {
                ...state,
                EmailSent: true,
                Message: action.Message
            };
        default:
            return state;
    }
};